import { c as _c } from "react/compiler-runtime";
import './nav-bag.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { getFeatureFlags, getPublicConfig } from '@sola/config/lib/getters.ts';
import { useCartDrawer } from '../../contexts/cart-drawer.tsx';
import { cartDrawerFocusTargetProps } from '../cart-drawer/cart-drawer.tsx';
const NavBagContents: React.FC<{
  displayCount: number | string | false;
}> = t0 => {
  const $ = _c(5);
  const {
    displayCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArkIcon iconName="shopping-bag-02" className="NavBag__icon" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== displayCount) {
    t2 = displayCount ? <span className="NavBag__count label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">{displayCount}</span> : null;
    $[1] = displayCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const NavBag: React.FC<{
  /** Marks the single persistent header control used for drawer focus return. */
  isCartDrawerFocusTarget?: boolean;
}> = t0 => {
  const $ = _c(24);
  const {
    isCartDrawerFocusTarget: t1
  } = t0;
  const isCartDrawerFocusTarget = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["priority"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const {
    openCartDrawer
  } = useCartDrawer();
  const {
    enableHeaderCartDrawer
  } = getFeatureFlags();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getPublicConfig();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    NEXT_PUBLIC_BASE_URL_CHECKOUT: checkoutBaseUrl
  } = t3;
  const {
    actions: t4,
    cart,
    isReady: cartIsReady
  } = useCart("actions", "cart", "isReady");
  const {
    getCart
  } = t4;
  const count = cartIsReady ? cart?.items?.length ?? 0 : 0;
  const displayCount = count && count > 9 ? "9+" : count;
  let t5;
  if ($[2] !== getCart) {
    t5 = () => {
      getCart();
    };
    $[2] = getCart;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  useEffect(t5, t6);
  let t7;
  if ($[5] !== t) {
    t7 = t("header.cart");
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const title = t7;
  if (!enableHeaderCartDrawer) {
    const t8 = cart?.checkoutUrl || checkoutBaseUrl;
    let t9;
    if ($[7] !== displayCount) {
      t9 = <NavBagContents displayCount={displayCount} />;
      $[7] = displayCount;
      $[8] = t9;
    } else {
      t9 = $[8];
    }
    let t10;
    if ($[9] !== t8 || $[10] !== t9 || $[11] !== title) {
      t10 = <Link className="NavBag flex p-comfy-xs relative" href={t8} title={title} aria-label={title}>{t9}</Link>;
      $[9] = t8;
      $[10] = t9;
      $[11] = title;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    return t10;
  }
  let t8;
  if ($[13] !== isCartDrawerFocusTarget) {
    t8 = isCartDrawerFocusTarget ? cartDrawerFocusTargetProps : {};
    $[13] = isCartDrawerFocusTarget;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== openCartDrawer) {
    t9 = () => openCartDrawer();
    $[15] = openCartDrawer;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== displayCount) {
    t10 = <NavBagContents displayCount={displayCount} />;
    $[17] = displayCount;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8 || $[21] !== t9 || $[22] !== title) {
    t11 = <button {...t8} type="button" className="NavBag p-comfy-xs relative" aria-label={title} onClick={t9}>{t10}</button>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t9;
    $[22] = title;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};